import React from "react";
import { Route, Redirect } from "react-router-dom";
import Cookies from "js-cookie";

export function AuthConditionedRoute({
    alert,
    component: Component,
    ...rest
}) {
    let userInfo = Cookies.get("userInfo");
    const isLogged = userInfo ? true : false; // For now isLogged if there's an authToken stored
    const conditionPassed = isLogged === rest.shouldBeLogged;
    if (userInfo) userInfo = JSON.parse(userInfo);

    return (
        <Route
            {...rest}
            render={props =>
                conditionPassed ? (
                    <Component {...props} userInfo={userInfo} alert={alert} />
                ) : (
                    <Redirect to={rest.pathIfFailedCondition} />
                )
            }
        />
    );
}
